import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'


const config = {
  apiKey: "AIzaSyANZfvShBin3335hPqCcldHpkYK1buAXMc",
  authDomain: "prowed-1745a.firebaseapp.com",
  databaseURL: "https://prowed-1745a.firebaseio.com",
  projectId: "prowed-1745a",
  storageBucket: "prowed-1745a.appspot.com",
  messagingSenderId: "282732789521"
}

firebase.initializeApp(config);

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase/index.js